import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import { PDFViewer, PDFDownloadLink, StyleSheet } from "@react-pdf/renderer";
import isTokenExpired from '../../PublicForms/isTokenExpired.js';
import { useNavigate } from "react-router-dom";
import Config from "../../PublicForms/Config.js";
import LoaderComp from "../../PublicForms/Loader.js";
import Pdf_Report_All_Subscript from "./Pdf_Report_All_Subscript.js";
import '../../../Styles/Components/Dashboards/Report/Pree_Pdf_Viewer.css';

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#d11fb6",
    color: "white",
  },
  section: {
    margin: 10,
    padding: 10,
  },
  viewer: {
    width: '100vw',
    height: '100vh',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
});

const Pree_Pdf_Report_All_Subscript = () => {
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState(0);
  const [runFilterDb, setRunFilterDb] = useState(true);
  const Navigate = useNavigate();
  const [message, setMessage] = useState([]);
  const [messTitle, setMessTitle] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [printData, setPrintData] = useState([]);
  const { remain, degree, province, city } = useParams();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
      }
    } else {
      Navigate("/login");
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // getlstAll
  useEffect(() => {
    const getListAll = async () => {
      const queryParts = [];
      if (remain && remain !== '-') queryParts.push(`remain=${remain}`);
      if (degree && degree !== '-') queryParts.push(`degree=${degree}`);
      if (province && province !== '-') queryParts.push(`province=${province}`);
      if (city && city !== '-') queryParts.push(`city=${city}`);

      const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';

      axios.get(
        `${Config.apiBaseUrl}/api/SubscriptDetails${queryString}`,
        {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
          }
        }
      ).then(response => {
        console.log(response)
        if (response.status === 200) {
          setPrintData(response.data);
          setLoading(false);
        } else {
          setLoading(false);
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "لطفا مجددا تلاش کنید",
          ]);
          setShowDialog(true);
        }
      }).catch((err) => {
        console.log(err)
        setLoading(false);
        if (err.response !== null && err.response !== undefined) {
          setMessage([]);
          if (err.response.status === 401) {
            Navigate("/login");
          } else if (err.response.status === 500) {
            setMessTitle("خطا");
            setMessage((prevMessages) => [
              ...prevMessages,
              err.response.data?.detail || "خطای سرور",
            ]);
            setShowDialog(true);
          } else {
            setMessTitle("خطا");
            setMessage((prevMessages) => [
              ...prevMessages,
              "لطفا مجددا تلاش کنید",
            ]);
            setShowDialog(true);
          }
        } else if (err.message === "Network Error") {
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "برقراری ارتباط با سرور امکان پذیر نمی باشد",
          ]);
          setShowDialog(true);
        } else {
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "لطفا مجددا تلاش کنید",
          ]);
          setShowDialog(true);
        }
      });

      setRunFilterDb(false);
    };

    if (runFilterDb === true) {
      getListAll();
    }
  }, [runFilterDb]);

  // ۱. حالت در حال لودینگ
  if (loading) {
    return (
      <div className="personLst">
        <p className="personLst-loader-txt">لطفا چند لحظه صبر کنید...</p>
        <div className="personLst-loader">
          <LoaderComp />
        </div>
      </div>
    );
  }

  // ۲. نمایش خطا در صورت بروز مشکل
  if (showDialog) {
    return (
      <div className="pree-factor-error" style={{ textAlign: "center", padding: "20px" }}>
        <h3>{messTitle}</h3>
        {message.map((msg, index) => (
          <p key={index} style={{ color: "red" }}>{msg}</p>
        ))}
      </div>
    );
  }

  // ۳. بررسی خالی نبودن دیتا
  if (!printData || (Array.isArray(printData) && printData.length === 0)) {
    return (
      <div className="pree-factor-empty" style={{ textAlign: "center", padding: "20px" }}>
        <p>داده‌ای برای گزارش‌گیری اشتراک‌ها یافت نشد.</p>
      </div>
    );
  }

  // ۴. رندر ویوور دسکتاپ و دکمه دانلود موبایل
  if (width > 768) {
    return (
      <div className='pree-factor' style={styles.viewer}>
        <div className="pdf" style={styles.viewer}>
          <PDFViewer width="100%" height="100vh" style={styles.viewer}>
            <Pdf_Report_All_Subscript printData={printData} />
          </PDFViewer>
        </div>
      </div>
    );
  } else {
    return (
      <div className='pree-factor'>
        <div className="pdf">
          <PDFDownloadLink
            className="pdf-download"
            document={<Pdf_Report_All_Subscript printData={printData} />}
            fileName='reportSubscriptMouood.pdf'
          >
            {({ blob, url, loading: pdfLoading, error }) =>
              pdfLoading ? 'در حال آماده‌سازی فایل PDF...' : 'دانلود'
            }
          </PDFDownloadLink>
        </div>
      </div>
    );
  }
};

export default Pree_Pdf_Report_All_Subscript;
